import React from 'react';
import SEO from '../components/SEO';
import { PageHero } from '../components/PageComponents';

const PrivacyPage = () => (
  <main className="pt-28 min-h-screen bg-white">
    <SEO
      title="Privacy Statement | Staffing Force - Gegevensbescherming AVG"
      description="Lees hoe Staffing Force Nederland B.V. omgaat met persoons- en organisatiegegevens via onze websites. AVG-conform beleid inzake cookies, e-mail en dataopslag."
    />

    <PageHero
      label="Juridisch"
      title="Privacy Statement"
      description="Hoe Staffing Force Nederland B.V. omgaat met jouw persoons- en organisatiegegevens via onze websites."
      image="https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1920&q=85&auto=format&fit=crop"
    />

    <section className="py-20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 prose prose-lg prose-gray">
        <p className="text-lg font-medium text-gray-800 leading-relaxed">
          In dit document wordt beschreven hoe jouw persoons- en/of organisatiegegevens door
          Staffing Force Nederland B.V. (hierna: Staffing Force) via haar websites zoals{' '}
          <a
            href="https://staffingforce.nl"
            className="text-[#00897B] underline"
            rel="noopener noreferrer"
          >
            https://staffingforce.nl
          </a>{' '}
          en dergelijke (hierna: Sites) worden behandeld.
        </p>

        <p className="text-gray-700 leading-relaxed mt-6">
          Wij verzamelen, gebruiken en delen persoons- en/of organisatiegegevens om de Sites van
          Staffing Force te laten werken. Staffing Force Nederland B.V., ingeschreven bij de KvK
          Gooi- en Eemland onder nummer 34276840, is verantwoordelijk voor de gegevensverwerking
          in de zin van de Algemene Verordening Gegevensbescherming (AVG). Door gebruik te maken
          van de site ga je akkoord met de algemene gebruikersovereenkomst en condities van dit
          Privacy beleid.
        </p>

        <h2 className="text-2xl font-bold text-gray-900 mt-14 mb-4">Cookies</h2>
        <p className="text-gray-700 leading-relaxed">
          Deze website maakt gebruik van &ldquo;cookies&rdquo; om het gebruik van onze Sites te
          analyseren. De informatie over het gebruik van de website kan worden overgebracht naar
          eigen beveiligde servers van Staffing Force of die van een derde partij. Wij gebruiken
          deze informatie om bij te houden hoe de website gebruikt wordt, om rapporten over de
          website-activiteit op te stellen en mogelijk andere diensten aan te bieden met
          betrekking tot website-activiteit en internetgebruik.
        </p>
        <p className="text-gray-700 leading-relaxed mt-4">
          Wij verzamelen gegevens voor onderzoek om zo een beter inzicht te krijgen in onze
          bezoekers, zodat wij onze diensten kunnen verbeteren en nog beter op onze doelgroep
          kunnen afstemmen. Staffing Force gebruikt Google Analytics om de prestaties van de
          Sites te monitoren en te optimaliseren om zo de best mogelijke gebruikservaring te
          bereiken.
        </p>

        <h2 className="text-2xl font-bold text-gray-900 mt-14 mb-4">
          Gebruik van informatie door Staffing Force
        </h2>
        <p className="text-gray-700 leading-relaxed">
          Je persoonlijke gegevens. Je laat ze bij ons achter, want dat wordt nu eenmaal van je
          gevraagd als je solliciteert. We kunnen ons voorstellen dat je je afvraagt wat er
          precies met je persoonsgegevens gebeurt.
        </p>
        <p className="text-gray-700 leading-relaxed mt-4">
          Wij gebruiken jouw gegevens voor verschillende doelen. Als je met ons in contact komt
          voor een mogelijke functie wordt er voor jou een account aangemaakt. In dit account
          zitten jouw CV, contactgegevens maar ook een korte omschrijving van waar je precies
          naar op zoek bent in je nieuwe functie. Om je goed te kunnen benaderen als we een
          interessante functie hebben, hebben we in ieder geval je naam, e-mailadres en
          telefoonnummer nodig. Kom je bij ons in dienst, dan hebben we bijvoorbeeld ook jouw
          adres, je rekeningnummer en geboortedatum nodig. Heb je al eens eerder bij ons
          gesolliciteerd, dan staan deze gegevens bij ons in het systeem. Ook als je telefonisch
          met ons gesproken hebt, wordt er in ons systeem opgeslagen wat er besproken is, zodat
          wij dit makkelijk kunnen achterhalen als we je opnieuw spreken. Deze gegevens bewaren
          wij maximaal 12 maanden.
        </p>
        <p className="text-gray-700 leading-relaxed mt-4">
          Alle gegevens die je bij ons achterlaat behandelen wij met uiterste zorg. Jouw gegevens
          worden opgeslagen op onze eigen beveiligde servers of die van een derde partij. Wij
          zullen deze gegevens niet combineren met andere persoonlijke gegevens waarover wij
          beschikken. Wij delen jouw gegevens en jouw CV niet met anderen, tenzij je ons daar
          vooraf toestemming voor geeft. Bijvoorbeeld als wij je met jouw CV voorstellen bij één
          van onze opdrachtgevers. We eisen dat onze opdrachtgevers net zo zorgvuldig met je
          gegevens omgaan als dat wij doen en dat zij deze alleen gebruiken voor het doel waarvoor
          hij ze gekregen heeft. Mocht je het gevoel hebben dat dit niet het geval is, laat dit
          dan per mail{' '}
          <a
            href="mailto:secretariaat@staffingforce.nl"
            className="text-[#00897B] underline"
          >
            secretariaat@staffingforce.nl
          </a>{' '}
          aan ons weten.
        </p>

        <h2 className="text-2xl font-bold text-gray-900 mt-14 mb-4">E-mails</h2>
        <p className="text-gray-700 leading-relaxed">
          Staffing Force stuurt maandelijks nieuwsbrieven uit, hiervoor gebruiken wij jouw
          e-mailadres. Wil je deze nieuwsbrieven niet meer ontvangen dan kun je dat bij ons
          aangeven en je hiervoor afmelden. Wanneer je ons een e-mail of ander berichten
          verzendt, is het mogelijk dat we deze berichten bewaren. Soms vragen wij naar
          persoonlijke gegevens die voor een bepaalde situatie relevant zijn. Dit zodat wij je
          vragen kunnen verwerken en beantwoorden. De gegevens worden opgeslagen op eigen
          beveiligde servers van Staffing Force of die van een derde partij. Wij zullen deze
          gegevens niet combineren met andere persoonlijke gegevens waarover wij beschikken.
        </p>
        <p className="text-gray-700 leading-relaxed mt-4">
          We zijn voortdurend bezig onze dienstverlening te verbeteren. Daarom kunnen we je
          gegevens gebruiken om je te vragen of je mee wilt doen aan een vrijblijvend
          marktonderzoek. Soms voeren anderen dat onderzoek voor ons uit. Wij geven die ander dan
          jouw e-mailadres. Die ander moet zich natuurlijk ook aan onze privacyregels houden. Zo
          moet je e-mailadres na afloop van het onderzoek worden verwijderd.
        </p>
        <p className="text-gray-700 leading-relaxed mt-4">
          Ook van onze zakelijke klanten en partners slaan wij gegevens van de contactpersoon op.
          Zijn het gegevens van personen, dan behandelen wij deze gegevens net zoals die van onze
          andere klanten.
        </p>

        <h2 className="text-2xl font-bold text-gray-900 mt-14 mb-4">Jouw gegevens blijven van jou</h2>
        <p className="text-gray-700 leading-relaxed">
          Wil je weten welke persoonsgegevens wij precies van je hebben? Vraag dan gerust een
          overzicht bij ons op. Je kan ons ook altijd vragen om de persoonsgegevens die wij van
          je hebben:
        </p>
        <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-700">
          <li>aan te passen</li>
          <li>te wissen</li>
          <li>over te dragen aan iemand anders</li>
        </ul>
        <p className="text-gray-700 leading-relaxed mt-4">
          Stuur je verzoek naar{' '}
          <a
            href="mailto:secretariaat@staffingforce.nl"
            className="text-[#00897B] underline"
          >
            secretariaat@staffingforce.nl
          </a>
          , dan maakt ons secretariaat het in orde. Heb je nog andere vragen? Je kan telefonisch
          contact met ons opnemen via{' '}
          <a href="tel:+31205811000" className="text-[#00897B] underline">
            020-5811000
          </a>
          .
        </p>
        <p className="text-gray-700 leading-relaxed mt-6">
          Wij kunnen dit privacy-beleid te allen tijde aanpassen. De aanpassingen zullen met
          onmiddellijke ingang van kracht worden. Wij raden je aan om regelmatig kennis te nemen
          van ons privacy-beleid om te zien of er veranderingen doorgevoerd zijn. Voor vragen
          over ons privacy-beleid kun je contact met ons opnemen. Dit kan per mail via{' '}
          <a
            href="mailto:secretariaat@staffingforce.nl"
            className="text-[#00897B] underline"
          >
            secretariaat@staffingforce.nl
          </a>{' '}
          of telefonisch op 020-5811000.
        </p>

        <div className="mt-14 pt-8 border-t border-gray-200 text-sm text-gray-500">
          <p>Dit privacy-beleid is aangepast op 24 mei 2018.</p>
          <p className="mt-1">Staffing Force Nederland B.V., 24 mei 2018.</p>
        </div>
      </div>
    </section>
  </main>
);

export default PrivacyPage;
